(function(){
  window.rpReady=1;
  var d=document,root=d.documentElement; root.classList.add('rpjs');
  function ready(fn){ if(d.readyState==='loading'){d.addEventListener('DOMContentLoaded',fn);}else{fn();} }
  ready(function(){
    d.querySelectorAll('.rp [data-load]').forEach(function(el){
      var i=parseInt(el.getAttribute('data-load'),10)||1; setTimeout(function(){el.classList.add('on');},80*i);
    });
    var rv=d.querySelectorAll('.rp [data-rv]');
    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('on');io.unobserve(e.target);}});},{rootMargin:'0px 0px -8% 0px',threshold:.06});
      rv.forEach(function(el){io.observe(el);});
    } else { rv.forEach(function(el){el.classList.add('on');}); }

    /* signup forms: come back to this post (Shopify sends article-page signups to the homepage otherwise) */
    d.querySelectorAll('.rp form').forEach(function(f){
      if(f.querySelector('input[name=return_to]')) return;
      var r=d.createElement('input'); r.type='hidden'; r.name='return_to';
      r.value=location.pathname+'?customer_posted=true#'+(f.id==='rp-form-top'?'rp-form-top':'get-five');
      f.appendChild(r);
    });

    /* keyword strip: repeat until it is wider than two screens, so there is never a gap */
    var mq=d.querySelector('.rp-mq-track');
    if(mq&&mq.innerHTML){ var base=mq.innerHTML, n=0; while(mq.scrollWidth<window.innerWidth*2.2&&n<6){ mq.innerHTML+=base; n++; } if(n%2===1){ mq.innerHTML+=base; } }

    d.querySelectorAll('.rp-check').forEach(function(b){
      b.addEventListener('click',function(){ b.setAttribute('aria-pressed', b.getAttribute('aria-pressed')==='true'?'false':'true'); });
    });
    d.querySelectorAll('.rp-step').forEach(function(s){
      function t(){ s.classList.toggle('is-done'); }
      s.addEventListener('click',t);
      s.addEventListener('keydown',function(e){ if(e.key==='Enter'||e.key===' '){e.preventDefault();t();} });
    });
    var pr=d.querySelector('.rp [data-print]'); if(pr){ pr.addEventListener('click',function(){window.print();}); }


    /* title: words rise one by one */
    var h1=d.querySelector('.rp-h1');
    var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if(h1&&!reduce){
      var words=h1.textContent.trim().split(/\s+/);
      h1.innerHTML=words.map(function(w,i){return '<span class="w"><span style="--wd:'+(i*70+120)+'ms">'+w.replace(/</g,'&lt;')+'</span></span>';}).join(' ');
      requestAnimationFrame(function(){requestAnimationFrame(function(){h1.classList.add('go');});});
    }
    /* numbers count up */
    function countUp(el){
      var m=el.textContent.match(/^(\d+)(.*)$/); if(!m||reduce) return;
      var end=parseInt(m[1],10), rest=m[2], t0=null, dur=900+end*12;
      if(end<2) return;
      function step(t){ if(!t0)t0=t; var p=Math.min(1,(t-t0)/dur), e=1-Math.pow(1-p,3);
        el.textContent=Math.round(end*e)+rest; if(p<1) requestAnimationFrame(step); }
      el.textContent='0'+rest; requestAnimationFrame(step);
    }
    var nums=d.querySelectorAll('.rp-facts b, .rp-nutri-row b');
    if('IntersectionObserver' in window){
      var nio=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){countUp(e.target);nio.unobserve(e.target);}});},{threshold:.6});
      nums.forEach(function(n){nio.observe(n);});
    }
    /* all ingredients ticked: toast */
    var toast=d.querySelector('.rp-toast'), checks=d.querySelectorAll('.rp-check'), shown=false;
    checks.forEach(function(b){ b.addEventListener('click',function(){
      var all=Array.prototype.every.call(checks,function(c){return c.getAttribute('aria-pressed')==='true';});
      if(all&&!shown&&toast){ shown=true; toast.classList.add('on'); setTimeout(function(){toast.classList.remove('on');},4200); }
      if(!all) shown=false;
    });});
    if(toast){ toast.addEventListener('click',function(){ var m=d.querySelector('.rp-method'); if(m) m.scrollIntoView({behavior:'smooth',block:'start'}); toast.classList.remove('on'); }); }
    /* hero photo drifts on scroll */
    var himg=d.querySelector('.rp-hero-img');
    var bar=d.querySelector('.rp-prog'), head=d.querySelector('.rp-head'), sticky=d.querySelector('.rp-sticky'),
        hero=d.querySelector('.rp-hero'), offer=d.querySelector('.rp-offer'), ticking=false;
    function onScroll(){
      var h=root.scrollHeight-root.clientHeight, y=window.scrollY||root.scrollTop;
      if(bar) bar.style.setProperty('--p', h>0 ? Math.min(1,y/h) : 0);
      if(head) head.classList.toggle('is-s', y>8);
      if(himg&&!reduce&&y<1200) himg.style.setProperty('--py', Math.min(y*0.06,18).toFixed(1)+'px');
      if(sticky && hero && offer){
        var pastHero = hero.getBoundingClientRect().bottom < 0;
        var oR = offer.getBoundingClientRect();
        var nearOffer = oR.top < window.innerHeight && oR.bottom > 0;
        sticky.classList.toggle('on', pastHero && !nearOffer);
      }
      ticking=false;
    }
    window.addEventListener('scroll',function(){ if(!ticking){ticking=true; requestAnimationFrame(onScroll);} },{passive:true});
    onScroll();
  });
})();
